import React from 'react';

import classNames from 'classnames';

import { Layout } from 'wanderu-components';

import styles from './TwoColumnLayout.scss';

function LeftColumn(props) {
    const {
        children,
        className: givenClassName,
        ...otherProps
    } = props;

    return (
        <div
            className={classNames(
                givenClassName,
                styles.leftColumn,
            )}
            {...otherProps}
        >
            {children}
        </div>
    );
}

function RightColumn(props) {
    const {
        children,
        className: givenClassName,
        ...otherProps
    } = props;

    return (
        <div
            className={classNames(
                givenClassName,
                styles.rightColumn,
            )}
            {...otherProps}
        >
            {children}
        </div>
    );
}

function TwoColumnLayout(props) {
    const {
        children,
        className: givenClassName,
        layoutClassName: givenLayoutClassName,
        ...otherProps
    } = props;

    return (
        <Layout
            className={classNames(
                givenClassName,
                givenLayoutClassName,
                styles.twoColumnLayout,
            )}
            {...otherProps}
        >
            {children}
        </Layout>
    );
}

export {
    LeftColumn,
    RightColumn,
    TwoColumnLayout,
};

export default TwoColumnLayout;
